import { render, staticRenderFns } from "./UserEduManagement.vue?vue&type=template&id=32373c58&"
import script from "./UserEduManagement.vue?vue&type=script&lang=js&"
export * from "./UserEduManagement.vue?vue&type=script&lang=js&"
import style0 from "./UserEduManagement.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports